<template>
    <div class="order-step-2__col order-step-2__col-1">
        <div class="order-step-2__text-container text-container inverted-colors">
            <h3>{{ title }}</h3>
            <p v-if="mode === 'business'">Bei einer Bürogrösse von mehr als 50 Mitarbeitenden beraten wir euch gerne persönlich. <a href="#" class="text" @click.prevent="toggleQuoteModalVisible">Hier weiter zum Formular.</a></p>
        </div>
        <div class="range-slider">
            <span class="range-slider__number range-slider__number--selected">{{ people }}</span>
            <input
                class="range-slider__input"
                name="people"
                type="range"
                :min="min"
                :max="max"
                :value="people"
                @input="updatePeople"
            >
            <span class="range-slider__number range-slider__number--total">{{ max }}</span>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    props: {
        min: {
            type: Number,
            default: 1,
            required: true,
        },
        max: {
            type: Number,
            default: 50,
            required: true,
        },
    },
    computed: {
        ...mapState({
            mode: state => state.mode,
            people: state => state.people,
        }),
        title() {
            return this.mode === 'business' ? 'Unsere Bürogrösse (Anzahl Mitarbeitende)' : 'Anzahl Bewohner';
        },
    },
    methods: {
        updatePeople(e) {
            const { mode } = this;
            const people = parseInt(e.target.value, 10);
            this.$store.dispatch('updatePeople', { people, mode });
        },
        toggleInfoModalVisible(content) {
            this.$store.commit('toggleInfoModalVisible', content);
        },
        toggleQuoteModalVisible() {
            this.$store.commit('toggleQuoteModalVisible');
        },
    },
};
</script>



// WEBPACK FOOTER //
// People.vue?3dd8e2d6